import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { CircularProgress } from "@mui/material";
import { useEffect } from "react";

const LoadingModal = ({ open, setOpen, showError }) => {
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (showError) showError(true);
    }, 300000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      id="loading-modal"
    >
      <Box
        sx={(theme) => ({
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "768px",
          height: "268px",
          bgcolor: "background.paper",
          borderRadius: "32px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          [theme.breakpoints.down("md")]: {
            width: "288px",
            height: "198px",
          },
        })}
        id="loading-modal-box"
      >
        <Box sx={{ display: "flex", marginBottom: "16px" }}>
          <CircularProgress size={32} sx={{ color: "#000" }} />
        </Box>
        <Typography
          sx={(theme) => ({
            fontSize: "24px",
            lineHeight: "32px",
            fontWeight: "500",
            [theme.breakpoints.down("md")]: {
              fontSize: "18px",
              lineHeight: "22px",
            },
          })}
          id="loading-modal-text"
        >
          Мы проверяем данные...
        </Typography>
      </Box>
    </Modal>
  );
};

export default LoadingModal;
